module.exports = __webpack_public_path__ + "advancedSlideAlt.jpg?7625989641d753c756dd0b17254c6a36";